/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";

import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { GET_DISCOUNT } from "../graphql";
import config from "../config/config.json";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetCouponsMethods extends IPluginMethodMap {
  getCouponsProps(args: any): Promise<any>;
}

export class GetCouponsService implements IAgentPlugin {
  readonly methods: IGetCouponsMethods;

  constructor() {
    this.methods = {
      getCouponsProps: this.getCouponsProps.bind(this),
    };
  }

  async getCouponsProps(args: any) {
    console.log(`===============>argslog`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let filter = {};
    let comm_pre_id: any = "",
      presentationOptions: any = [],
      defaultPresentation: any = "", defaulttype: any = "";
    defaultPresentation = args?.compProps?.defaultPresentations;
    defaulttype = args?.compProps?.type;
    filter = {
      ...filter,
      presentation: args?.criteria?.presentation ?? defaultPresentation,
    };
    if (args?.criteria?.type) {
      filter = {
        ...filter,
        discountType: args?.criteria?.type
      }
    }
    if (args?.criteria?.name) {
      filter = {
        ...filter,
        name: args?.criteria?.name
      }
    }
    if (args?.criteria?.status) {
      filter = {
        ...filter,
        status: args?.criteria?.status
      }
    }

    try {
      const res = await client.query({
        query: GET_DISCOUNT,
        variables: {
          filter: filter,
          options: {
            limit: args?.size ?? 10,
            skip: args?.offset ?? 0
          },
        },
        fetchPolicy: "network-only",
      });
      const tableData = this.formatCouponsTable(res?.data?.getAllDiscounts?.content);
      let _totalPages = res?.data?.getAllDiscounts?.count
        ? Math.ceil(parseInt(res?.data?.getAllDiscounts?.count) / 10)
        : 1;

      let _currentPage =
        res?.data?.getAllDiscounts?.skip / res?.data?.getAllDiscounts?.limit + 1;

      return {
        ultUsers: tableData?.length,

        config: { ...config, createdCoupons: { tableData } },
        defaultPresentations:
          args?.criteria?.presentation ?? defaultPresentation,

        defaultdtype:
          args?.criteria?.type ?? defaultPresentation,
        isEmpty: res?.data?.getAllDiscounts?.content?.length <= 0,
        activePage: _currentPage,
        currentPage: _currentPage,
        pageSize: res?.data?.getAllDiscounts?.limit,
        totalCount: res?.data?.getAllDiscounts?.count,
        searchPresentationFilter: presentationOptions,
        // tableHeaders: this.updatePresentationOptions(
        //   settingConfig.tableHeaders,
        //   presentationOptions
        // ),
        totalPages: _totalPages,
      };
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private formatCouponsTable(data: any) {
    let _rowData: any = [];
    data.forEach((item: any) => {
      _rowData.push({
        id: item?._id,
        discountName: item?.name,
        discountType: item?.discountType,
        discountValue: item?.value,
        startDate: item?.startDate,
        endDate: item?.endDate,
        totalNumberofDiscounts: item?.usageLimit,
        presentationName: item?.presentation?.name,
        presentationId: item?.presentation?.id,
        section: item?.section?.name,
        sectionType: item?.sectionType?.name,
        couponSrc: item?.img,
        totalCoupons: item?.usageLimit,
        totalUsedCoupons: item?.usedCount,
        totalRemainingCoupons: item?.usageLimit - item?.usedCount,
        couponStatus: item?.status,
      });
    });
    console.log(_rowData);
    return _rowData;
  }
}
